import { convertToDateTime } from '../../../helpers/dateHelpers';
import './StripCalendarEventDetails.scss';

const StripCalendarEventDetails = ({blockDate, className, event, value}) => {  

    let dayBeforeBlockDateStart = new Date(+blockDate.start);
    dayBeforeBlockDateStart.setDate(dayBeforeBlockDateStart.getDate()-1);

    let dayAfterBlockDateEnd = new Date(+blockDate.end);
    dayAfterBlockDateEnd.setDate(dayAfterBlockDateEnd.getDate()+1);

    const condition = className === 'event__id' ? event.specialEvent : !event.specialEvent;
    const carryInCondition = event.carryIn && condition && convertToDateTime(event.start_date, '00:00') !== dayBeforeBlockDateStart.getTime();
    const carryOutCondition = event.carryOut && condition && convertToDateTime(event.end_date, '23:59') !== dayAfterBlockDateEnd.getTime()

    return (    
        <div
            id={event.unique_id} 
            className={
                carryInCondition ? `${className} event__carry-over-arrow--ci` 
                : carryOutCondition ? `${className} event__carry-over-arrow--co` 
                : className
            }
            style={{ 
                marginLeft: event.releasePaddingLeft+'%', 
                minHeight: className === 'event__layover'  && !event.specialEvent ? '1.5rem' : 0, 
                paddingLeft: carryInCondition ? '1rem' : 0 
            }}
            title={className === 'event__id' && value}
        >
            {value}
        </div>
    )
}

export default StripCalendarEventDetails;